import { Box, Typography } from "@mui/material";
import React from "react";
import loadCountIcon from "../../../assets/images/icons/loadCount.svg";
import unloadCountIcon from "../../../assets/images/icons/unloadCount.svg";

interface CityNameCellRendererProps {
  value: string;
  loadCount?: number;
  unloadCount?: number;
}

const CityNameCellRenderer: React.FC<CityNameCellRendererProps> = ({
  value,
  loadCount,
  unloadCount,
}) => {
  const extractCityName = (location: string): string => {
    if (!location) return "";
    const [city] = location.split(" -");
    return city.trim();
  };

  const cityName = extractCityName(value);

  return (
    <div
      style={{
        height: "40px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        columnGap: "8px",
        minWidth: "210px", // Larghezza minima
      }}
    >
      <Typography
        sx={{
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          flexGrow: 1, // Permette al testo di occupare lo spazio disponibile
        }}
      >
        {cityName}
      </Typography>
      {loadCount && loadCount > 1 ? (
        <Box
          sx={{
            backgroundColor: "primary.main",
            borderRadius: "20px",
            display: "flex",
            flexDirection: "row",
            columnGap: "4px",
            width: "64px",
            minWidth: "64px",
            padding: "2px 12px",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <img src={loadCountIcon} alt="load Count" />
          <Typography sx={{ color: "white", fontSize: "15px" }}>
            {loadCount}
          </Typography>
        </Box>
      ) : (
        ""
      )}

      {unloadCount && unloadCount > 1 ? (
        <Box
          sx={{
            backgroundColor: "primary.main",
            borderRadius: "70px",
            display: "flex",
            flexDirection: "row",
            columnGap: "4px",
            width: "64px",
            minWidth: "64px",
            padding: "2px 12px",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <img src={unloadCountIcon} alt="Unload count" />
          <Typography sx={{ color: "white", fontSize: "15px" }}>
            {unloadCount}
          </Typography>
        </Box>
      ) : (
        ""
      )}
    </div>
  );
};

export default CityNameCellRenderer;
